import type { DecisionEngineDestinationUI } from "./definition";

export const mongodbUI: DecisionEngineDestinationUI = {
  campaignSetup: "freeform",
  resourceName: "recommendation",
  channelDescription: "MongoDB",
  getReferenceString: (s) => `{{ ${s} }}`,
  isPreviewSupported: false,
  isTestSendSupported: true,
};
